import HttpService from "./http.service";

class PaymentService extends HttpService {
    paymentDetails = (params) => this.getOrderPaymentDetails("payment/listPaymentOfOrders", params);
    listPaymentGateways = () => this.getPaymentGateways("payment/retrievePaymentGatewayInfomation");
    createPaymentOrder = (data) => this.getOrderPaymentDetails("payment/createOrder", data);
    createReservationPayment = (data) => this.getOrderPaymentDetails("payment/createReservationPayment", data);
}

export default new PaymentService();